import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'

import { QuizProvider } from './state/QuizContext'
import { StorefrontProvider } from './state/StorefrontContext'
import { IframeBridge } from './components/IframeBridge'
import { IntroScreen } from './screens/IntroScreen'
import { ActivityScreen } from './screens/ActivityScreen'
import { PainScreen } from './screens/PainScreen'
import { ShapeScreen } from './screens/ShapeScreen'
import { HeightScreen } from './screens/HeightScreen'
import { LoadingScreen } from './screens/LoadingScreen'
import { ResultScreen } from './screens/ResultScreen'

function AnimatedRoutes() {
  const location = useLocation()

  return (
    <>
      <IframeBridge />
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={location.pathname}>
          <Route path="/"             element={<IntroScreen    />} />
          <Route path="/questions/1"  element={<ActivityScreen />} />
          <Route path="/questions/2"  element={<PainScreen     />} />
          <Route path="/questions/3"  element={<ShapeScreen    />} />
          <Route path="/questions/4"  element={<HeightScreen   />} />
          <Route path="/loading"      element={<LoadingScreen />} />
          <Route path="/result"       element={<ResultScreen  />} />
          <Route path="*"             element={<Navigate to="/" replace />} />
        </Routes>
      </AnimatePresence>
    </>
  )
}

export default function App() {
  return (
    <StorefrontProvider>
      <QuizProvider>
        <BrowserRouter>
          <AnimatedRoutes />
        </BrowserRouter>
      </QuizProvider>
    </StorefrontProvider>
  )
}
